const styles = {
  wrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: 18,

    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
  },
  input: {
    border: '1px solid #E2E2FC',

    borderRadius: 8,
    padding: '0 12px',
    backgroundColor: '#FFFFFF',
    width: '100%',
    height: 32,
    fontSize: 16,
    color: '#707087',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    '&::-webkit-input-placeholder ': {
      color: '#707087',
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      opacity: 1,
    },
    '&:-ms-input-placeholder': {
      color: '#707087',
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      opacity: 1,
    },
    '&::placeholder': {
      color: '#707087',
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      opacity: 1,
    },
  },
  description: {
    color: '#707087',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    marginTop: '2px',
    fontStyle: 'italic',
  },
  pickerWrap: {
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    pointerEvents: 'none',
  },
  error: {
    fontSize: 12,
    color: '#FF0000',
    marginBottom: 1,
  },
  emptyMargin: {
    height: 18,
  },
}

export { styles }
